import { createRouter, createWebHistory } from 'vue-router';
import WelcomeScreen from '@/components/WelcomeScreen';
import JurySelection from '../components/JurySelection.vue';
import EvaluationScreen from '../components/EvaluationScreen.vue';
import ResultsScreen from '../components/ResultsScreen.vue';

const routes = [
  {
    path: '/',
    name: 'WelcomeScreen',  // Set this as the initial screen route
    component: WelcomeScreen,
  },
  {
    path: '/jury-selection',
    name: 'JurySelection',
    component: JurySelection, // Jury selection screen as the next step
  },
  {
    path: '/evaluation',
    name: 'EvaluationScreen',
    component: EvaluationScreen,
  },
  {
    path: '/results',
    name: 'ResultsScreen',
    component: ResultsScreen,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;